import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDirectory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.52148 4.74003H5.86434M2.52148 8H5.86434M2.52148 11.26H5.86434M5.35363 14.5H12.3179C12.959 14.5 13.4786 13.9803 13.4786 13.3393V2.66071C13.4786 2.01967 12.959 1.5 12.3179 1.5H5.35363C4.71258 1.5 4.19291 2.01967 4.19291 2.66071V13.3393C4.19291 13.9803 4.71258 14.5 5.35363 14.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDirectory;
